import PropTypes from 'prop-types';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} CustomPanel
 * @prop {string} size Size of the panel
 * @prop {string} url Url to the custom panel
 */
export default PropTypes.shape({
  size: PropTypes.string,
  url: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/propTypes/customPanel.js